// Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

// Modules

export class Footer extends Component {
    render() {
        const { footer } = this.props;
        return (
            <section style={footer.styles} className={classNames('footer', footer.classes)}>
                <div className="left"> {footer.left} </div>
                <div className="center"> {footer.center} </div>
                <div className="right"> {footer.right} </div>
            </section>
        );
    }
}

Footer.propTypes = {
    footer: PropTypes.object.isRequired
};

export default connect(state => {
    return (
        {
            footer: state.footer
        }
        );
}
)(Footer);



// WEBPACK FOOTER //
// ./src/components/SharedComponents/footer.js